export default __webpack_public_path__ + "static/media/graphsetting.a1c3ae1f.png";